import { fetchWithHandling } from "utils/common-utils";
import { OperationsTipology, CreateOperationsTipologyRq, UpdateOperationsTipologyRq } from "utils/interfaces";

const API_URL = `${process.env.REACT_APP_BACKEND_API_PREFIX}/api/v1/operations-tipology`;

export const getAll = async (
    jwtToken: string,
    onSessionExpired: () => void
): Promise<OperationsTipology[]> => {
    try {
        const jsonData = await fetchWithHandling(
            API_URL,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${jwtToken}`,
                },
            },
            () => { onSessionExpired(); }
        );
        return (jsonData as OperationsTipology[]) ?? [];
    } catch (error) {
        return [];
    }
};

export const create = async (
    jwtToken: string,
    onSessionExpired: () => void,
    data: CreateOperationsTipologyRq
): Promise<OperationsTipology | null> => {
    try {
        const jsonData = await fetchWithHandling(
            API_URL,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${jwtToken}`,
                },
                body: JSON.stringify(data),
            },
            () => { onSessionExpired(); }
        );
        return jsonData as OperationsTipology;
    } catch (error) {
        return null;
    }
};

export const update = async (
    jwtToken: string,
    onSessionExpired: () => void,
    data: UpdateOperationsTipologyRq
): Promise<OperationsTipology | null> => {
    try {
        const jsonData = await fetchWithHandling(
            API_URL,
            {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${jwtToken}`,
                },
                body: JSON.stringify(data),
            },
            () => { onSessionExpired(); }
        );
        return jsonData as OperationsTipology;
    } catch (error) {
        return null;
    }
};

export const deleteOperationsTipology = async (
    jwtToken: string,
    onSessionExpired: () => void,
    id: number
): Promise<boolean> => {
    try {
        await fetchWithHandling(
            `${API_URL}/${id}`,
            {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${jwtToken}`,
                },
            },
            () => { onSessionExpired(); }
        );
        return true;
    } catch (error) {
        return false;
    }
};
